import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { keepAlive: true }
  },
  {
    path: '/goin',
    name: 'goin',
    component: () => import('../views/GoinView.vue'),
    meta: {
      title: '关于弗鲁微 - 连续流技术专家团队与制造实力 | flwsd.com',
      keywords: '弗鲁微公司介绍，微反应器研发团队，连续流设备生产基地，化工装备制造',
      description:'了解山东弗鲁微科技有限公司：一家拥有专业研发团队、高端精密机械加工车间、完备连续流实验室和化工装置撬装试验站的高新技术企业，致力于为化工行业提供可靠的连续流技术装备与服务。'
    }
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/ProductsView.vue'),
    meta: {
      title: '连续流反应器产品系列 - 微通道/动态管式/固定床/微气泡反应器/连续结晶器/格氏反应器/微反应撬装 | 弗鲁微科技',
      keywords: '动态管式反应器，微通道反应器价格，微气泡反应器厂家，微混合器，连续流反应器选型',
      description:'浏览弗鲁微科技全系列连续流反应设备：动态管式反应器、微通道反应器、微气泡反应器及微混合器。详细了解各产品特点、应用领域及技术参数，为您的工艺升级选配精准装备。'
    }
  },
  {
    path: '/productDetail/:id',
    name: 'productDetail',
    component: () => import('../views/ProductDetailView.vue'),
    meta: {
      title: '山东弗鲁微科技 - 连续流微反应器装备制造商 | 微化工技术解决方案',
      keywords: '微反应器，连续流技术，连续化，微通道反应器，动态管式反应器，微混合器，微气泡，连续结晶，格氏反应器，微化工设备，连续流装备，连续流工艺优化，连续反应，工艺包开发，硝化反应，氯化反应，加氢反应，弗鲁微科技',
      description:'山东弗鲁微科技有限公司是专业的连续流装备制造商，提供微通道反应器、动态管式反应器、微气泡反应器、连续结晶器、格氏反应器等系列产品及硝化、氯化、氧化、重氮化、加氢、丁基锂、格氏等危险工艺的连续流解决方案。从实验室研发到工业化撬装放大，为您提供安全、高效、精准的微化工技术一站式服务。'
    }
  },
  {
    path: '/cases',
    name: 'cases',
    component: () => import('../views/CaseView.vue'),
    meta: {
      title: '连续流工艺研发案例 - 硝化/氯化/加氢/重氮化应用 | 弗鲁微科技',
      keywords:'连续流硝化案例，微反应器加氢工艺，氯化反应连续化，重氮化安全生产，化工工艺案例',
      description:'查看弗鲁微科技在硝化、氯化、加氢、重氮化、缩合等危险化工工艺中的成功连续流技术应用案例，包括叶酸合成、达格列净合成等，为您提供工艺优化参考。'
    }
  },
  {
    path: '/caseDetail/:id',
    name: 'caseDetail',
    component: () => import('../views/CaseDetailView.vue'),
    meta: {
      title: '山东弗鲁微科技 - 连续流微反应器装备制造商 | 微化工技术解决方案',
      keywords: '微反应器，连续流技术，连续化，微通道反应器，动态管式反应器，微混合器，微气泡，连续结晶，格氏反应器，微化工设备，连续流装备，连续流工艺优化，连续反应，工艺包开发，硝化反应，氯化反应，加氢反应，弗鲁微科技',
      description:'山东弗鲁微科技有限公司是专业的连续流装备制造商，提供微通道反应器、动态管式反应器、微气泡反应器、连续结晶器、格氏反应器等系列产品及硝化、氯化、氧化、重氮化、加氢、丁基锂、格氏等危险工艺的连续流解决方案。从实验室研发到工业化撬装放大，为您提供安全、高效、精准的微化工技术一站式服务。'
    }
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/NewsView.vue'),
    meta: {
      title: '山东弗鲁微科技 - 连续流微反应器装备制造商 | 微化工技术解决方案',
      keywords: '微反应器，连续流技术，连续化，微通道反应器，动态管式反应器，微混合器，微气泡，连续结晶，格氏反应器，微化工设备，连续流装备，连续流工艺优化，连续反应，工艺包开发，硝化反应，氯化反应，加氢反应，弗鲁微科技',
      description:'山东弗鲁微科技有限公司是专业的连续流装备制造商，提供微通道反应器、动态管式反应器、微气泡反应器、连续结晶器、格氏反应器等系列产品及硝化、氯化、氧化、重氮化、加氢、丁基锂、格氏等危险工艺的连续流解决方案。从实验室研发到工业化撬装放大，为您提供安全、高效、精准的微化工技术一站式服务。'
    }
  },
  {
    path: '/newsDetail/:id',
    name: 'newsDetail',
    component: () => import('../views/NewDetailView.vue'),
    meta: {
      title: '山东弗鲁微科技 - 连续流微反应器装备制造商 | 微化工技术解决方案',
      keywords: '微反应器，连续流技术，连续化，微通道反应器，动态管式反应器，微混合器，微气泡，连续结晶，格氏反应器，微化工设备，连续流装备，连续流工艺优化，连续反应，工艺包开发，硝化反应，氯化反应，加氢反应，弗鲁微科技',
      description:'山东弗鲁微科技有限公司是专业的连续流装备制造商，提供微通道反应器、动态管式反应器、微气泡反应器、连续结晶器、格氏反应器等系列产品及硝化、氯化、氧化、重氮化、加氢、丁基锂、格氏等危险工艺的连续流解决方案。从实验室研发到工业化撬装放大，为您提供安全、高效、精准的微化工技术一站式服务。'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
    meta: {
      title: '联系我们 - 获取连续流技术方案与设备报价 | 弗鲁微科技',
      keywords: '微反应器厂家联系方式，连续流设备报价，化工技术合作，弗鲁微科技电话',
      description:'立即联系弗鲁微科技销售与技术支持团队！欢迎咨询连续流设备报价、工艺合作开发或定制化需求。电话：13210867858 / 13210877008。' 
    }
  },
  {
    path: '/technology',
    name: 'technology',
    component: () => import('../views/TechnologyView.vue'),
    meta: {
      title: '山东弗鲁微科技 - 连续流微反应器装备制造商 | 微化工技术解决方案',
      keywords: '微反应器，连续流技术，连续化，微通道反应器，动态管式反应器，微混合器，微气泡，连续结晶，格氏反应器，微化工设备，连续流装备，连续流工艺优化，连续反应，工艺包开发，硝化反应，氯化反应，加氢反应，弗鲁微科技',
      description:'山东弗鲁微科技有限公司是专业的连续流装备制造商，提供微通道反应器、动态管式反应器、微气泡反应器、连续结晶器、格氏反应器等系列产品及硝化、氯化、氧化、重氮化、加氢、丁基锂、格氏等危险工艺的连续流解决方案。从实验室研发到工业化撬装放大，为您提供安全、高效、精准的微化工技术一站式服务。'
    }
  },
]

const router = new VueRouter({
  // mode: 'hash',
  // base: process.env.BASE_URL,
  // routes,
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

  // ----------------------------------------------
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})


router.afterEach((to) => {
  const defaultTitle = '弗鲁微科技 - 连续流微反应器装备制造商 | 微化工技术解决方案'
  const defaultKeywords = '微反应器，连续流技术，连续化，微通道反应器，动态管式反应器，微混合器，微气泡，连续结晶，格氏反应器，微化工设备，连续流装备，连续流工艺优化，连续反应，工艺包开发，硝化反应，氯化反应，加氢反应，弗鲁微科技'
  const defaultDescription = '山东弗鲁微科技有限公司是专业的连续流装备制造商，提供微通道反应器、动态管式反应器、微气泡反应器、连续结晶器、格氏反应器等系列产品及硝化、氯化、氧化、重氮化、加氢、丁基锂、格氏等危险工艺的连续流解决方案。从实验室研发到工业化撬装放大，为您提供安全、高效、精准的微化工技术一站式服务。'

  // 设置标题
  document.title = to.meta?.title || defaultTitle

  // 设置 keywords
  let keywordsMeta = document.querySelector('meta[name="keywords"]')
  if (!keywordsMeta) {
    keywordsMeta = document.createElement('meta')
    keywordsMeta.name = 'keywords'
    document.head.appendChild(keywordsMeta)
  }
  keywordsMeta.content = to.meta?.keywords || defaultKeywords

  // 设置 description
  let descriptionMeta = document.querySelector('meta[name="description"]')
  if (!descriptionMeta) {
    descriptionMeta = document.createElement('meta')
    descriptionMeta.name = 'description'
    document.head.appendChild(descriptionMeta)
  }
  descriptionMeta.content = to.meta?.description || defaultDescription
})

export default router